import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DesktopIcon, StyledLoadingButton } from './NextButton.styles';
export const NextButton = ({
  autoFocus = false,
  buttonLabel = 'button.next',
  className,
  isEnabled = false,
  showIcon = true,
  onClick,
  dataSelenium,
  label,
  loading = false
}) => {
  return /*#__PURE__*/_jsxs(StyledLoadingButton, {
    autoFocus: autoFocus,
    className: className,
    disabled: !isEnabled,
    size: 'medium',
    type: 'submit',
    use: 'primary',
    onClick: onClick,
    "data-selenium": dataSelenium,
    label: label,
    loading: loading,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: buttonLabel
    }), showIcon && /*#__PURE__*/_jsx(DesktopIcon, {
      name: "right",
      role: "img"
    })]
  });
};